import { headers, parseJSON } from '../../apiUtils';

export function fetchSurveyFormsSummary() {
    const path = `/api/SurveyFormV3/surveyforms-summary`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchTeamsSummary() {
    const path = `/api/adminV3/teams-summary`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchTeamsHierarchy() {
    const path = `/api/adminV3/teams-hierarchy`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchUsersSummary() {
    const path = `/api/adminV3/users-summary`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function _saveSurvey(surveyToSave) {
    return fetch('/api/SurveyFormV3/surveyform', {
        headers: headers(),
        method: 'POST',
        body: JSON.stringify(surveyToSave)
    }).then(parseJSON);
}

export function _terminateUser(userId) {
    return fetch(`/api/adminV3/terminateUser?userId=${userId}`, {
        headers: headers(),
        method: 'POST'
    }).then(parseJSON);
}

export function _activateUser(userId) {
    return fetch(`/api/adminV3/activateUser?userId=${userId}`, {
        headers: headers(),
        method: 'POST'
    }).then(parseJSON);
}

export function _createNewUser(newUser) {
    const url = `/api/adminV3/create-user`;
    return fetch(url, {
        headers: headers(),
        body: JSON.stringify(newUser),
        method: 'POST'
    });
}

export function _createNewTeam(newTeam) {
    const url = `/api/adminV3/create-team`;
    return fetch(url, {
        headers: headers(),
        body: JSON.stringify(newTeam),
        method: 'POST'
    });
}

export function _updateUser(userUpdateInfo) {
    const url = `/api/adminV3/update-user`;
    return fetch(url, {
        headers: headers(),
        body: JSON.stringify(userUpdateInfo),
        method: 'PUT'
    });
}